"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNKNOWN_SURCHARGE_TOOLTIP = exports.SURCHARGE_TEXT = exports.SMALL_CARD_SURCHARGE_TEXT = exports.KNOWN_SURCHARGE_TOOLTIP = void 0;
var _localization = require("@lt/localization");
var KNOWN_SURCHARGE_TOOLTIP = exports.KNOWN_SURCHARGE_TOOLTIP = _localization.i18n.t('hotelcard.card.constants.known');
var UNKNOWN_SURCHARGE_TOOLTIP = exports.UNKNOWN_SURCHARGE_TOOLTIP = _localization.i18n.t('hotelcard.card.constants.unknown');
var SMALL_CARD_SURCHARGE_TEXT = exports.SMALL_CARD_SURCHARGE_TEXT = _localization.i18n.t('hotelcard.card.constants.small');
var SURCHARGE_TEXT = exports.SURCHARGE_TEXT = _localization.i18n.t('hotelcard.card.constants.surcharge');